// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__ONwqJ","inputWrap":"styles_inputWrap__1PgTN","input":"styles_input__1qZi3"};